<template>
  <v-layout>
    <v-flex xs12>
      <div style="margin-top: 15px;"></div>
      <span class="subheading">Buscar pelo QRCode</span>
      <span class="subheading details">Toque para iniciar a camera</span>
      <div ref="container" class="centered grey lighten-4">

        <div v-if="qrScanner" id="camera-container">
          <qr-reader id="reader" v-show="!loadingCamera && !cameraError" @init="onInit"
                     @decode="onQrcodeDecoded" :paused="paused"></qr-reader>
          <div v-if="flashSuccess" class="animation-flash flash-div success">
            <span><v-icon class="white--text" size="80">check</v-icon></span>
          </div>
          <div v-if="flashError" class="animation-flash flash-div fail">
            <span><v-icon class="white--text" size="80">clear</v-icon></span>
          </div>
        </div>

        <v-btn class="cam grey lighten-1" v-show="!qrScanner" @click="initQrCodeScanner">
          <v-icon>photo_camera</v-icon>&nbsp;Escanear QRCode
        </v-btn>

        <span class="camera-error" v-if="cameraError">{{cameraErrorMessage}}</span>

        <v-progress-circular indeterminate color="primary" v-show="loadingCamera"
                             style="margin: 0 auto;"></v-progress-circular>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  }

  // Some browsers partially implement mediaDevices. We can't just assign an object
  // with getUserMedia as it would overwrite existing properties.
  // Here, we will just add the getUserMedia property if it's missing.
  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {

      // First get ahold of the legacy getUserMedia, if present
      var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

      // Some browsers just don't implement it - return a rejected promise with an error
      // to keep a consistent interface
      if (!getUserMedia) {
        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
      }

      // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    };
  }
  import {QrcodeReader} from 'vue-qrcode-reader'

  export default {
    name: "QrCodeReaderComponent",
    components: {
      'qr-reader': QrcodeReader
    },
    props: {
      paused: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        qrScanner: null,
        loadingCamera: false,
        cameraError: false,
        cameraErrorMessage: null,
        flashSuccess: false,
        flashError: false
      }
    },
    methods: {
      initQrCodeScanner: function () {
        this.qrScanner = true;
        this.loadingCamera = true;
      },
      async onInit(promise) {
        try {
          await promise;
          // successfully initialized
        } catch (error) {
          this.showErrorMessage(error);
          this.qrScanner = false;
        } finally {
          this.loadingCamera = false;
        }
      },
      onQrcodeDecoded: function (data) {
        let self = this;
        this.$emit('capture', {code: data});
      },
      showErrorMessage: function (error) {
        this.cameraError = true;
        let message = '';
        if (error.name === 'NotAllowedError') {
          message = 'Acesso à camera negado'
        } else if (error.name === 'NotFoundError') {
          message = 'Nenhuma camera compatível encontrada';
        } else if (error.name === 'NotSupportedError') {
          message = 'Page is not served over HTTPS (or localhost)'
        } else if (error.name === 'NotReadableError') {
          message = 'Verifique se a camera já está em uso'
        } else if (error.name === 'OverconstrainedError') {
          message = "Problemas ao identificar a camera";
        } else {
          message = 'Seu navegador provavelmente não suporta recursos os recursos WebRTC ou Canvas';
        }
        // return this.cameraErrorMessage = message;
        this.notify.error(this, message, 'Problema ao carregar camera', 7000);
      },
      flash: function (type) {
        let self = this;
        return new Promise((resolve, reject) => {
          if (type === 'success')
            this.flashSuccess = true;
          if (type === 'fail')
            this.flashError = true;
          setTimeout(() => {
            self.flashSuccess = self.flashError = false;
            resolve();
          }, 1000);
        });
      }
    }
  }
</script>

<style scoped>

  #reader {
    width: 100%;
    height: auto;
  }

  .centered {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 21vh;
    margin-top: 1vh;
  }

  .centered .cam {
    min-height: 21vh;
    width: 100%;
  }

  span.subheading {
    display: block;
  }

  span.subheading.details {
    font-size: 12px !important;
  }

  .mb {
    margin-bottom: 15px;
    margin-top: 15px;
  }

  /* Animação */
  #camera-container {
    position: relative;
  }

  .success {
    background-color: #00b894;
  }

  .fail {
    background-color: #f41f1f;
  }

  .animation-flash {
    text-align: center;
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    animation-name: Flash;
    animation-iteration-count: 1;
    animation-duration: 0.9s;
  }

  .animation-flash span {
    position: relative;
    float: left;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @keyframes Flash {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/consulta/QrCodeReader.vue